import { useState } from "react";
import { CreditCard, Send, Loader2 } from "lucide-react";

export function BookingPayment({ booking, onRequest }) {
  const [busy, setBusy] = useState(false);
  const b = booking;
  const id = b.booking_id;
  if (b.payment_status === "paid") return <span className="dg-chip ml-2 align-middle text-emerald-300" data-testid={`paid-${id}`}>Paid ${Number(b.deposit_usd || 0).toFixed(2)}{b.paid_at ? ` · ${new Date(b.paid_at).toLocaleDateString()}` : ""}</span>;
  if (b.status === "cancelled" || b.payment !== "after_session" || !(b.deposit_usd > 0)) return null;
  const send = async () => { setBusy(true); try { await onRequest(id); } finally { setBusy(false); } };
  return (
    <span className="inline-flex flex-wrap items-center gap-2 ml-2 align-middle">
      <span className="dg-chip text-amber-300" data-testid={`unpaid-${id}`}>Pay after session · ${Number(b.deposit_usd).toFixed(2)}{b.payment_requested_at ? ` · link sent ${new Date(b.payment_requested_at).toLocaleDateString()}` : ""}</span>
      <button type="button" onClick={send} disabled={busy} className="dg-btn-ghost rounded-full px-3 py-1 text-xs flex items-center gap-1 disabled:opacity-50" data-testid={`request-payment-${id}`}>
        {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : b.payment_requested_at ? <Send className="w-3 h-3" /> : <CreditCard className="w-3 h-3" />} {b.payment_requested_at ? "Resend payment link" : "Send payment link"}
      </button>
    </span>
  );
}
